// /utils/LaserHit.js

import React, { useEffect, useState } from 'react';

const LaserHit = () => {
  const [hits, setHits] = useState([]);

  useEffect(() => {
    let timeoutId;

    const createLaserHit = () => {
      const newTop = Math.floor(Math.random() * 91);  // Valeurs en pourcentage
      const newLeft = Math.floor(Math.random() * 91);
      const id = Date.now();

      setHits((prevHits) => [
        ...prevHits,
        {
          id,
          topPct: newTop,
          leftPct: newLeft,
          fading: false,
        },
      ]);

      setTimeout(() => {
        setHits((prevHits) =>
          prevHits.map((hit) =>
            hit.id === id ? { ...hit, fading: true } : hit
          )
        );

        setTimeout(() => {
          setHits((prevHits) => prevHits.filter((hit) => hit.id !== id));
        }, 1750);
      }, 550);

      // Prochain délai aléatoire (4s à 7s)
      const nextDelay = Math.floor(Math.random() * 3000) + 4000;
      timeoutId = setTimeout(createLaserHit, nextDelay);
    };

    timeoutId = setTimeout(createLaserHit, Math.floor(Math.random() * 3000) + 4000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <>
      {hits.map((hit) => (
        <div
          key={hit.id}
          className={`laser-hit top-${hit.topPct}p left-${hit.leftPct}p ${hit.fading ? 'fading' : ''}`}
        />
      ))}
    </>
  );
};

export default LaserHit;
